module.exports = __webpack_public_path__ + "media/checkout/secure-39f2a29f.png";